export enum ReportPeriod {
  Day = 'Day',
  Week = 'Week',
}

export const periodOptions = [{
  value: ReportPeriod.Day,
  label: 'Shown by day',
}, {
  value: ReportPeriod.Week,
  label: 'Shown by week',
}]